import type { FormFields, FormErrors } from '../formFields'

import { useFormMeta } from '@workwave-tidal/form-fairy'

export function useSubmitDisabled() {
  const { meta } = useFormMeta<FormFields, FormErrors>()

  return meta.validating || meta.submitting
}
